import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import Chart from 'react-google-charts';

const AdministrationDays = () => {
  const data = [
    ['Month', 'Admin Days'],
    ['January', 2],
    ['February', 2],
    ['March', 2],
    ['April', 2],
    ['May', 2],
  ];

  const options = {
    title: 'Administration Days',
    hAxis: { title: 'Month' },
    vAxis: { title: 'Days Reserved' },
    legend: { position: 'top' },
    bar: { groupWidth: '75%' },
    colors: ['#FF9800'],
  };

  return (
    <Col className="col-sm-12 col-xl-6 box-col-6">
      <Card>
        <CardBody>
          <Chart
            width={'100%'}
            height={'400px'}
            chartType="BarChart"
            loader={<div>Loading Chart...</div>}
            data={data}
            options={options}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

export default AdministrationDays;